const getSafeString = (value?: string | null) => {
    if (!value) return '';
    return `${value}`;
};

export default getSafeString;
